import { framesConstants } from '../constants';

export const framesReducer = (state = {}, action) => {
    switch(action.type) {
        case framesConstants.GET_ALL_FRAMES_REQUEST:
            return {
                ...state,
                getAllFramesProcess: true
            }

        case framesConstants.GET_ALL_FRAMES_SUCCESS:
            return {
                ...state,
                list: {...state.list, ...action.payload},
                getAllFramesProcess: false,
                getAllFramesError: false
            }
        case framesConstants.GET_ALL_FRAMES_FAILURE:
            return {
                ...state,
                getAllFramesProcess: false,
                getAllFramesError: true
            }

        case framesConstants.UPLOAD_FRAME_FAILURE:
            return {
                ...state,
                uploadFrameProcess: false,
                uploadFrameError: true
            }
            
        case framesConstants.UPLOAD_FRAME_REQUEST:
            return {
                ...state,
                uploadFrameProcess: true
            }
        
        case framesConstants.UPLOAD_FRAME_SUCCESS:
            return {
                ...state,
                list: {...state.list, ...action.payload},
                uploadFrameProcess: false,
                uploadFrameError: false,
            }

        case framesConstants.UPDATE_FRAME_FAILURE:
            return {
                ...state,
                updateFrameProcess: false,
                updateFrameError: true
            }
            
        case framesConstants.UPDATE_FRAME_REQUEST:
            return {
                ...state,
                updateFrameProcess: true
            }
        
        case framesConstants.UPDATE_FRAME_SUCCESS:
            return {
                ...state,
                list: {...state.list, ...action.payload},
                updateFrameProcess: false,
                updateFrameError: false,
            }

        case framesConstants.DELETE_FRAME_FAILURE:
            return {
                ...state,
                deleteFrameProcess: false,
                deleteFrameError: true
            }
            
        case framesConstants.DELETE_FRAME_REQUEST:
            return {
                ...state,
                deleteFrameProcess: true
            }
        
        case framesConstants.DELETE_FRAME_SUCCESS:
            return {
                ...state,
                list: {...state.list, [action.payload.eventID]: undefined},
                deleteFrameProcess: false,
                deleteFrameError: false,
            }

        default:
            return state;
    }
}

export default framesReducer;


// WEBPACK FOOTER //
// ./src/reducers/frames.js